export enum OnboardingDataEventObject {
  ADMIN_WIZARD_CREATED_RESOURCES = 'admin_wizard_created_resources',
  ADMIN_WIZARD_CREATED_RESOURCES_NAVIGATE_TO_SETTINGS_SHARED_INBOX = 'admin_wizard_created_resources_navigate_to_settings_shared_inbox',
  ADMIN_WIZARD_CREATED_RESOURCES_NAVIGATE_TO_SETTINGS_RULES = 'admin_wizard_created_resources_navigate_to_settings_rules',
  ADMIN_WIZARD_CREATED_RESOURCES_NAVIGATE_TO_SETTINGS_CIRCLE = 'admin_wizard_created_resources_navigate_to_settings_circle',

  ADMIN_WIZARD_INBOX = 'admin_wizard_inbox',
  ADMIN_WIZARD_EXIT = 'admin_wizard_exit',
  ADMIN_WIZARD_ERROR = 'admin_wizard_error',
  ADMIN_WIZARD_INBOX_GOALS_NEXT = 'admin_wizard_inbox_goals_next',
  ADMIN_WIZARD_INBOX_GOALS_PREVIOUS = 'admin_wizard_inbox_goals_previous',
  ADMIN_WIZARD_INBOX_GOALS_SKIP = 'admin_wizard_inbox_goals_skip',
  ADMIN_WIZARD_INBOX_NEXT = 'admin_wizard_inbox_next',

  ADMIN_WIZARD_INBOX_PREVIOUS = 'admin_wizard_inbox_previous',
  ADMIN_WIZARD_INBOX_SKIP = 'admin_wizard_inbox_skip',
  ADMIN_WIZARD_ONBOARDING_USE_CASE = 'admin_wizard_onboarding_use_case',
  ADMIN_WIZARD_ONBOARDING_USE_CASE_NEXT = 'admin_wizard_onboarding_use_case_next',
  ADMIN_WIZARD_ONBOARDING_CHARACTERISTICS = 'admin_wizard_onboarding_characteristics',
  ADMIN_WIZARD_ONBOARDING_CHARACTERISTICS_SKIP = 'admin_wizard_onboarding_characteristics_skip',
  ADMIN_WIZARD_ONBOARDING_CHARACTERISTICS_PREVIOUS = 'admin_wizard_onboarding_characteristics_previous',
  ADMIN_WIZARD_ONBOARDING_CHARACTERISTICS_NEXT = 'admin_wizard_onboarding_characteristics_next',

  ADMIN_WIZARD_VIEW_INBOX = 'admin_wizard_view_inbox',
  ADMIN_WIZARD_DONE = 'admin_wizard_done',

  ADMIN_SETUP_GUIDE_RULES_ITEM = 'admin_setup_guide_rules_item',

  ADMIN_WIZARD_WORKFLOWS = 'admin_wizard_inbox_goals',

  ADMIN_WIZARD_WORKFLOWS_CREATE_TOPIC_ROUTING_RULE = 'admin_wizard_workflows_create_topic_routing_rule',
  ADMIN_WIZARD_WORKFLOWS_CREATE_TOPIC_ROUTING_RULE_SKIP = 'admin_wizard_workflows_create_topic_routing_rule_skip',
  ADMIN_WIZARD_WORKFLOWS_CREATE_TOPIC_ROUTING_RULE_PREVIOUS = 'admin_wizard_workflows_create_topic_routing_rule_previous',
  ADMIN_WIZARD_WORKFLOWS_CREATE_TOPIC_ROUTING_RULE_NEXT = 'admin_wizard_workflows_create_topic_routing_rule_next',
  ADMIN_WIZARD_WORKFLOWS_CREATE_SLA_RULE = 'admin_wizard_workflows_create_sla_rule',
  ADMIN_WIZARD_WORKFLOWS_CREATE_SLA_RULE_SKIP = 'admin_wizard_workflows_create_sla_rule_skip',
  ADMIN_WIZARD_WORKFLOWS_CREATE_SLA_RULE_PREVIOUS = 'admin_wizard_workflows_create_sla_rule_previous',
  ADMIN_WIZARD_WORKFLOWS_CREATE_SLA_RULE_NEXT = 'admin_wizard_workflows_create_sla_rule_next',
  ADMIN_WIZARD_WORKFLOWS_CREATE_ASSIGN_RULE = 'admin_wizard_workflows_create_assign_rule',
  ADMIN_WIZARD_WORKFLOWS_CREATE_ASSIGN_RULE_SKIP = 'admin_wizard_workflows_create_assign_rule_skip',
  ADMIN_WIZARD_WORKFLOWS_CREATE_ASSIGN_RULE_PREVIOUS = 'admin_wizard_workflows_create_assign_rule_previous',
  ADMIN_WIZARD_WORKFLOWS_CREATE_ASSIGN_RULE_NEXT = 'admin_wizard_workflows_create_assign_rule_next',

  WELCOME_GUIDE_INTRO = 'welcome_guide_intro',
  WELCOME_GUIDE_INTRO_START = 'welcome_guide_intro_start',
  WELCOME_GUIDE_CONNECT_CHANNEL = 'welcome_guide_connect_channel',
  WELCOME_GUIDE_CONNECT_CHANNEL_ADVANCED_SETTINGS = 'welcome_guide_connect_channel_advanced_settings',
  WELCOME_GUIDE_CONNECT_CHANNEL_SKIP = 'welcome_guide_connect_channel_skip',
  WELCOME_GUIDE_CONNECT_CHANNEL_PREVIOUS = 'welcome_guide_connect_channel_previous',
  WELCOME_GUIDE_CONNECT_CHANNEL_DONE = 'welcome_guide_connect_channel_done',

  SHARED_INBOX_GUIDE_INBOX = 'shared_inbox_guide_inbox',
  SHARED_INBOX_GUIDE_CONFIRMATION = 'shared_inbox_guide_confirmation',

  AI_ONBOARDING_TOPICS_AVAILABLE_TIP = 'ai_onboarding_topics_available_tip',
  AI_ONBOARDING_TOPICS_UNAVAILABLE_TIP = 'ai_onboarding_topics_unavailable_tip',
  AI_ONBOARDING_PROMPT_TOPIC_RULES_TIP = 'ai_onboarding_prompt_topic_rules_tip',
  AI_ONBOARDING_CONFIGURE_INBOX_ECHOES = 'ai_onboarding_configure_inbox_echoes',

  ADMIN_SETUP_GUIDE_OPEN = 'admin_setup_guide_open',
  ADMIN_SETUP_GUIDE_SCREEN = 'screen',
  SUPPORT_PORTAL = 'support_portal',
  ADMIN_SETUP_GUIDE_MORE_RESOURCES = 'more_resources',
  ADMIN_SETUP_GUIDE_DISMISS_PERMANENTLY = 'dismiss_permanently',

  ADMIN_SETUP_GUIDE_PRODUCT_DEMOS_TAB = 'product_demos_tab',
  ADMIN_SETUP_GUIDE_PRODUCT_DEMOS_CORE = 'product_demos_core',
  ADMIN_SETUP_GUIDE_PRODUCT_DEMOS_ANALYTICS = 'product_demos_analytics',
  ADMIN_SETUP_GUIDE_PRODUCT_DEMOS_CHAT = 'product_demos_chat',

  ADMIN_SETUP_GUIDE_BASICS_CHECKLIST_TAB = 'basics_checklist_tab',
  ADMIN_SETUP_GUIDE_BASICS_CHECKLIST_ITEM = 'basics_checklist_item',

  ADMIN_SETUP_GUIDE_ADVANCED_CHECKLIST_TAB = 'advanced_checklist_tab',
  ADMIN_SETUP_GUIDE_ADVANCED_CHECKLIST_ITEM = 'advanced_checklist_item',

  ADMIN_SETUP_GUIDE_DISCOVER_AI_TAB = 'discover_ai_tab',
  ADMIN_SETUP_GUIDE_DISCOVER_AI_ITEM = 'discover_ai_item',

  ADMIN_SETUP_GUIDE_GET_MORE_LMS_TAB = 'get_more_lms_tab',
  ADMIN_SETUP_GUIDE_GET_MORE_LMS_COURSE = 'get_more_lms_course',

  ADMIN_SETUP_GUIDE_PERSONAL_CHANNEL_REMINDER = 'admin_setup_guide_personal_channel_reminder',
  ADMIN_SETUP_GUIDE_PERSONAL_CHANNEL_REMINDER_OKAY = 'admin_setup_guide_personal_channel_okay',
  ADMIN_SETUP_GUIDE_PERSONAL_CHANNEL_REMINDER_CANCEL = 'admin_setup_guide_personal_channel_cancel',

  FRONT_LINE_USER_SETUP_GUIDE_SCREEN = 'front_line_user_screen',
  FRONT_LINE_USER_SETUP_GUIDE_SCREEN_OPEN = 'front_line_user_setup_guide_screen_open',
  FRONT_LINE_USER_SETUP_GUIDE_SCREEN_CLOSE = 'front_line_user_setup_guide_screen_close',
  FRONT_LINE_USER_SETUP_GUIDE_GET_STARTED_TAB = 'front_line_user_setup_guide_get_started_tab',
  FRONT_LINE_USER_SETUP_GUIDE_GET_STARTED_ITEM = 'front_line_user_setup_guide_get_started_item',
  FRONT_LINE_USER_SETUP_GUIDE_MORE_TAB = 'front_line_user_setup_guide_more_tab',
  FRONT_LINE_USER_SETUP_GUIDE_GET_MORE_LMS_COURSE = 'front_line_user_setup_guide_get_more_lms_course',

  TAGS_COURSE_VIEW = 'tags_course_view',
  ROUTING_CONVERSATIONS_COURSE_VIEW = 'routing_conversations_course_view',
  KNOWLEDGE_BASE_COURSE_VIEW = 'knowledge_base_course_view',

  BASICS_GUIDE_WHAT_IS_A_CHANNEL_VIEW = 'basics_guide_what_is_a_channel_view',
  BASICS_GUIDE_WHAT_IS_A_CHANNEL_NEXT = 'basics_guide_what_is_a_channel_next',
  BASICS_GUIDE_WHAT_IS_A_CHANNEL_CANCEL = 'basics_guide_what_is_a_channel_cancel',
  BASICS_GUIDE_WHAT_IS_A_CHANNEL_STEP_LIST = 'basics_guide_what_is_a_channel_step_list',
  BASICS_GUIDE_WHAT_IS_AN_INBOX_VIEW = 'basics_guide_what_is_an_inbox_view',
  BASICS_GUIDE_WHAT_IS_AN_INBOX_NEXT = 'basics_guide_what_is_an_inbox_next',
  BASICS_GUIDE_WHAT_IS_AN_INBOX_PREVIOUS = 'basics_guide_what_is_an_inbox_previous',
  BASICS_GUIDE_WHAT_IS_AN_INBOX_CANCEL = 'basics_guide_what_is_an_inbox_cancel',
  BASICS_GUIDE_WHAT_IS_AN_INBOX_STEP_LIST = 'basics_guide_what_is_an_inbox_step_list',
  BASICS_GUIDE_ROUTING_BETWEEN_INBOXES_VIEW = 'basics_guide_routing_between_inboxes_view',
  BASICS_GUIDE_ROUTING_BETWEEN_INBOXES_NEXT = 'basics_guide_routing_between_inboxes_next',
  BASICS_GUIDE_ROUTING_BETWEEN_INBOXES_PREVIOUS = 'basics_guide_routing_between_inboxes_previous',
  BASICS_GUIDE_ROUTING_BETWEEN_INBOXES_CANCEL = 'basics_guide_routing_between_inboxes_cancel',
  BASICS_GUIDE_ROUTING_BETWEEN_INBOXES_STEP_LIST = 'basics_guide_routing_between_inboxes_step_list',
  BASICS_GUIDE_INBOX_ORGANIZATION_VIEW = 'basics_guide_inbox_organization_view',
  BASICS_GUIDE_INBOX_ORGANIZATION_NEXT = 'basics_guide_inbox_organization_next',
  BASICS_GUIDE_INBOX_ORGANIZATION_PREVIOUS = 'basics_guide_inbox_organization_previous',
  BASICS_GUIDE_INBOX_ORGANIZATION_CANCEL = 'basics_guide_inbox_organization_cancel',
  BASICS_GUIDE_INBOX_ORGANIZATION_STEP_LIST = 'basics_guide_inbox_organization_step_list',
  BASICS_GUIDE_BEST_PRACTICES_VIEW = 'basics_guide_best_practices_view',
  BASICS_GUIDE_BEST_PRACTICES_NEXT = 'basics_guide_best_practices_next',
  BASICS_GUIDE_BEST_PRACTICES_PREVIOUS = 'basics_guide_best_practices_previous',
  BASICS_GUIDE_BEST_PRACTICES_CANCEL = 'basics_guide_best_practices_cancel',
  BASICS_GUIDE_BEST_PRACTICES_STEP_LIST = 'basics_guide_best_practices_step_list',
  BASICS_GUIDE_END_CTA_VIEW = 'basics_guide_end_cta_view',
  BASICS_GUIDE_END_CTA_CANCEL = 'basics_guide_end_cta_cancel',
  BASICS_GUIDE_DONE = 'basics_guide_done',

  CHANNEL_WIZARD_VIEW_CONNECT_CHANNEL_SLIDE = 'channel_wizard_view_connect_channel_slide',
  CHANNEL_WIZARD_CANCEL_CONNECT_CHANNEL_SLIDE = 'channel_wizard_cancel_connect_channel_slide',
  CHANNEL_WIZARD_STARTED_CONNECTING_CHANNEL = 'channel_wizard_started_connecting_channel',
  CHANNEL_WIZARD_ADVANCED_CHANNEL_SETTINGS_CTA = 'channel_wizard_advanced_channel_settings_cta',
  CHANNEL_WIZARD_VIEW_SELECT_INBOX_SLIDE = 'channel_wizard_view_select_inbox_slide',
  CHANNEL_WIZARD_CANCEL_SELECT_INBOX_SLIDE = 'channel_wizard_cancel_select_inbox_slide',
  CHANNEL_WIZARD_SELECT_INBOX_SLIDE_PREVIOUS = 'channel_wizard_select_inbox_slide_previous',
  CHANNEL_WIZARD_VIEW_CREATE_NEW_INBOX_DIALOG = 'channel_wizard_view_create_new_inbox_dialog',
  CHANNEL_WIZARD_DONE = 'channel_wizard_done',

  QUICK_INVITE_POPOVER_VIEW = 'quick_invite_popover_view',
  QUICK_INVITE_POPOVER_CANCEL = 'quick_invite_popover_cancel',
  QUICK_INVITE_POPOVER_UPGRADE_PLAN_BILLING_CTA = 'quick_invite_popover_upgrade_plan_billing_cta',
  QUICK_INVITE_POPOVER_ADD_MORE_TEAMMATES_BILLING_CTA = 'quick_invite_popover_add_more_teammates_billing_cta',
  QUICK_INVITE_POPOVER_ADVANCED_TEAMMATE_SETTINGS_CTA = 'quick_invite_popover_advanced_teammate_settings_cta',
  QUICK_INVITE_POPOVER_INVITE = 'quick_invite_popover_invite',

  PURCHASE = 'purchase',

  DEMO_INTRO_POPOVER_VIEW = 'demo_intro_popover_view',
  DEMO_INTRO_POPOVER_START_SUPPORT_DEMO = 'demo_intro_popover_start_support_demo',
  DEMO_INTRO_POPOVER_START_ANALYTICS_DEMO = 'demo_intro_popover_start_analytics_demo',
  DEMO_INTRO_POPOVER_START_LIVE_CHAT_DEMO = 'demo_intro_popover_start_live_chat_demo',
  DEMO_INTRO_POPOVER_EXPLORE_LATER = 'demo_intro_popover_explore_later',
  DEMO_INTRO_POPOVER_CANCEL = 'demo_intro_popover_cancel',

  DEMO_ASSIGN = 'demo_convo_assigned_prompt',
  DEMO_CONVO = 'demo_convo_got_it',
  DEMO_MENTION = 'demo_convo_mention_prompt',

  DEMO_TICKET_STATUS_OPEN = 'demo_convo_ticket_status_open',
  DEMO_TICKET_STATUS_RESOLVED = 'demo_convo_ticket_status_resolved',

  DEMO_REPLY_TO_EMAIL = 'demo_convo_reply_to_email',
  DEMO_REFINE_TONE = 'demo_convo_refine_tone',
  DEMO_SEND_ARCHIVE = 'demo_convo_send_archive',
  DEMO_STATUS_CLARITY = 'demo_convo_status_clarity',
  DEMO_STATUS_CLARITY_NEXT = 'demo_convo_status_clarity_next',
  DEMO_STATUS_CLARITY_END = 'demo_convo_status_clarity_end',

  DEMO_RULES_APPLIED = 'demo_convo_see_rules_applied',
  DEMO_RULES_INTRO = 'demo_convo_see_automation',
  DEMO_RULES_SLA_TIMER = 'demo_convo_see_rules_sla_timer',
  DEMO_RULES_SLA_TIMER_NEXT = 'demo_convo_see_rules_sla_timer_next_demo',
  DEMO_RULES_SLA_TIMER_END = 'demo_convo_see_rules_sla_timer_end_demo',

  DEMO_ANALYTICS_INTRO = 'demo_analytics_intro',
  DEMO_ANALYTICS_MORE = 'demo_analytics_more',
  DEMO_ANALYTICS_MORE_END = 'demo_analytics_more_end',

  DEMO_CHAT_INTRO = 'demo_chat_intro',
  DEMO_CHAT_SHOWCASE_KNOWLEDGE_BASE = 'demo_chat_showcase_knowledge_base',
  DEMO_CHAT_TEAMMATE_HANDOFF = 'demo_chat_teammate_handoff',

  DEMO_AI_ANSWERS_INTRO = 'demo_ai_answers_intro',
  DEMO_AI_ANSWERS_SHOWCASE_AI_ANSWERS = 'demo_ai_answers_showcase_ai_answers',
  DEMO_AI_ANSWERS_SHOWCASE_AUTOMATION = 'demo_ai_answers_showcase_automation',
  DEMO_AI_ANSWERS_TEAMMATE_HANDOFF = 'demo_ai_answers_teammate_handoff',

  DEMO_WELCOME = 'learn_basics',
  DEMO_WELCOME_SKIP = 'learn_basics_skip',
  DEMO_WELCOME_START = 'learn_basics_start',

  ONBOARDING_TEAMMATE_WORKSPACE = 'onboarding_teammate_workspace',
  ONBOARDING_TEAMMATE_WORKSPACE_NEXT = 'onboarding_teammate_workspace_next',
  ONBOARDING_TEAM_WORKSPACE = 'onboarding_team_workspace',
  ONBOARDING_TEAM_WORKSPACE_NEXT = 'onboarding_team_workspace_next',

  INBOX_EMPTY_STATE_ADMIN_CTA = 'inbox_empty_state_admin_cta',
  INBOX_EMPTY_STATE_ADMIN_CTA_OPEN_SETUP_GUIDE = 'inbox_empty_state_admin_cta_open_setup_guide',
  INBOX_EMPTY_STATE_FRONT_LINE_USER_CTA_OPEN_SETUP_GUIDE = 'inbox_empty_state_front_line_user_cta_open_setup_guide',
  INBOX_EMPTY_STATE_TEAMMATE_CTA = 'inbox_empty_state_teammate_cta',
  INBOX_EMPTY_STATE_TEAMMATE_CTA_ADD_GOOGLE_CHANNEL = 'inbox_empty_state_teammate_cta_add_google_channel',
  INBOX_EMPTY_STATE_TEAMMATE_CTA_ADD_MICROSOFT_CHANNEL = 'inbox_empty_state_teammate_cta_add_microsoft_channel',
  INBOX_EMPTY_STATE_TEAMMATE_CTA_ADD_OTHER_CHANNEL = 'inbox_empty_state_teammate_cta_add_other_channel',
  INBOX_EMPTY_STATE_TEAMMATE_CTA_DISMISS = 'inbox_empty_state_teammate_cta_dismiss',
  INBOX_EMPTY_STATE_AI_ONBOARDING_CTA = 'inbox_empty_state_ai_onboarding_cta',
  INBOX_EMPTY_STATE_AI_ONBOARDING_CONNECT_CHANNEL = 'inbox_empty_state_ai_onboarding_connect_channel',

  ONBOARDING_QUESTIONNAIRE_SKIP = 'onboarding_questionnaire_skip',
  ONBOARDING_QUESTIONNAIRE_START_SETUP = 'onboarding_questionnaire_start_setup',
  ONBOARDING_QUESTIONNAIRE_VIEW = 'onboarding_questionnaire_view',

  DESKTOP_RECOMMENDATION_DIALOG_CLOSE = 'desktop_recommendation_dialog_close',
  DOWNLOAD_DESKTOP_APP = 'download_desktop_app',

  NOTIFICATIONS_PERMISSION_BANNER_VIEW = 'notifications_permission_banner_view',
  NOTIFICATIONS_PERMISSION_BANNER_ENABLE = 'notifications_permission_banner_enable',
  NOTIFICATIONS_PERMISSION_BANNER_DISMISS = 'notifications_permission_banner_dismiss',

  ONBOARDING_TIP = 'onboarding_tip',
}
